import React from "react";

export default function AmenityEntityBlankComponent(props: any) {
	const { title, subTitle, type } = props;

	return (
		<div
			style={{
				height: '100%',
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				border: "1px solid #E8E8E8",
				borderRadius: "4px",
				marginTop: "20px",
				background: "#FAFAFA",
				padding: "50px 0px"
			}}
		>
			{
				type == 'amenities' ?
					<img
						style={{ height: "70px", marginBottom: "20px" }}
						src="images/logo/feature-search.png"
					/>
				:type == 'amenityEvents' ?
					<img
						style={{ height: "70px", marginBottom: "20px" }}
						src="images/logo/unknown-document.png"
					/>
				:type == 'accessInformation' ?
					<img
						style={{ height: "70px", marginBottom: "20px" }}
						src="images/logo/event-busy.png"
					/>
				:
				<img
					style={{ height: "70px", marginBottom: "20px" }}
					src="images/logo/no-wallpaper.png"
				/>	
			}
			<span style={{ marginTop: '12px', fontSize: "18px" }} className="text-787878-24px">{title}</span>
			<span style={{ marginTop: '10px', fontSize: "14px" }} className="text-787878-16px">{subTitle}</span>
		</div>
	);
};